<template>
    <form-generator :schema="formSchema" :value="value"></form-generator>
</template>

<script>
import HocFormGenerator from '@/components/FormGenerator/HocFormGenerator';
import FormLayout from './UserFormLayout';

const FormGenerator = HocFormGenerator(FormLayout);

export default {
    name: 'UserReadForm',
    components: {
        'form-generator': FormGenerator
    },
    props: {
        value: {
            type: Object,
            required: false,
            default: () => {}
        },
        allowXocField: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        xocAuthField() {
            if (this.allowXocField) {
                return {
                    name: 'xocAuth',
                    label: 'MSO user'
                };
            }
            return {
                name: 'placeHolder',
                label: 'placeholder'
            };
        },
        usernameField() {
            return {
                name: 'username',
                label: 'Username'
            };
        },
        formSchema() {
            return [
                {
                    name: 'email',
                    label: 'Email'
                },
                this.xocAuthField,
                this.usernameField,
                {
                    name: 'firstName',
                    label: 'First name'
                },
                {
                    name: 'lastName',
                    label: 'Last name'
                }
            ];
        }
    }
};
</script>

<style scoped lang="scss"></style>
